import { paths } from "./paths";
import { IMAGES as Images } from "./image";


const servicesData = {
  heading: "Our Services",
  catchPhrase: "Pre-Engineered Building & Steel Manufacturing Solutions",
  heroImage: Images?.Futurebackground,
  heroImagePosition: "center",
  content: `Linktext:GLOBAL INFRA PROJECTS;Linkto:https://globalinfraprojects.com/; specializes in Boldtext:Pre-Engineered Building (PEB) manufacturing, structural steel fabrication, and industrial infrastructure solutions;. We design and build Boldtext:industrial sheds, warehouses, factory buildings, logistics hubs, and commercial steel structures; using high-quality structural steel. Our expert team delivers Boldtext:durable, cost-efficient, and fast construction solutions; through precision engineering, advanced fabrication technology, and efficient project execution. From Boldtext:design and manufacturing to installation;, GLOBAL INFRA PROJECTS ensures strong, reliable, and future-ready steel structures for modern industries.`,
  moreText: "See All Services",
  moreLink: paths?.services,
  services: [
    {
      id: "peb-manufacturers-coimbatore",
      imgSrc: Images?.pebService,
      imgAlt: "PRE ENGINEERED BUILDINGS ",
      heading: "PRE ENGINEERED BUILDINGS - Superior Quality Steel Structures ",
      content:
        "Advanced steel building systems designed for maximum efficiency and durability. Our Pre-Engineered Buildings combine innovative engineering with superior materials to deliver structures that stand the test of time.",
      moreText: "View more",
      url: "https://globalinfraprojects.com/services/peb-manufacturers-coimbatore/",

    },
    {
      id: "composite-steel-concrete-buildings-coimbatore",
      imgSrc: Images?.steelConstruction,
      imgAlt: "COMPOSITE BUILDINGS",
      heading: "COMPOSITE BUILDINGS- Steel Structure with Concrete Pillars",
      content:
        "Hybrid construction technology that combines the strength of steel frameworks with the stability of concrete pillars. Perfect for projects requiring enhanced load-bearing capacity and architectural flexibility.",
      moreText: "View more",
      url: "https://globalinfraprojects.com/services/composite-steel-concrete-buildings-coimbatore/",
    },
    //container
    {
      id: "container-house-manufacturers-coimbatore",
      imgSrc: Images?.modernHomeContainer,
      imgAlt: "MODERN HOME CONTAINERS",
      heading: "MODERN HOME CONTAINERS- Stunning Sustainable Living Spaces",
      content:
        "Transform industrial shipping containers into beautiful, modern homes. Our innovative container architecture delivers eco-friendly, cost-effective housing solutions without compromising on style or comfort.",
      moreText: "View more",
      url: "https://globalinfraprojects.com/services/container-house-manufacturers-coimbatore/",
    },
  ],
  moreHeading: "Partner with GLOBAL INFRA PROJECTS",
  moreContent:
    `Planning a Boldtext:warehouse, factory building, industrial shed, or commercial steel structure?; GLOBAL INFRA PROJECTS provides complete Boldtext:PEB manufacturing and steel construction solutions; tailored to your project requirements.With strong engineering expertise and advanced steel fabrication capabilities, we deliver Boldtext:high-quality, durable, and scalable infrastructure; for growing businesses. Linktext:Contact our team today;Linkto:https://globalinfraprojects.com/contact-us; Boldtext:to discuss your project requirements and get expert guidance for your next steel building project;.`,
};

export default servicesData;
